import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';

const ShowbizPreviewHeader = (props) => {
 

  return (
    <React.Fragment>

      <Helmet>
        <link rel="stylesheet" href={process.env.PUBLIC_URL + "/showbiz-assets/css/style.css"} />
        <link rel="stylesheet" href={process.env.PUBLIC_URL + "/showbiz-assets/css/widgets.css"} />
        <link rel="stylesheet" href={process.env.PUBLIC_URL + "/showbiz-assets/css/color.css"} />
        <link rel="stylesheet" href={process.env.PUBLIC_URL + "/showbiz-assets/css/responsive.css"} />
        <link rel="stylesheet" href={process.env.PUBLIC_URL + "/showbiz-assets/showbiz.css"} />

      </Helmet>

      <header className="main-header header-style-2 position-sticky t--0">
        <div className="header-bottom header-sticky background-white text-center">
          <div className="scroll-progress gradient-bg-1"></div>

          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-6 text-left">
                <div className="header-logo d-none d-lg-block text-left">
                  <a href="/">
                    <img className="logo-img d-inline" src={process.env.PUBLIC_URL + "/showbiz-assets/images/logo-showbiz.svg"} alt="" style={{ width: '200px' }} />
                  </a>
                </div>
                <div className="logo-tablet d-md-inline d-lg-none d-none  text-left">
                  <a href="/">
                    <img className="logo-img d-inline" src={process.env.PUBLIC_URL + "/showbiz-assets/images/logo-showbiz.svg"} alt="" style={{ width: '200px' }} />
                  </a>
                </div>
                <div className="logo-mobile d-block d-md-none">
                  <a href="/">
                    <img className="logo-img d-inline" src={process.env.PUBLIC_URL + "/showbiz-assets/images/logo-showbiz.svg"} alt="" style={{ width: '150px' }} />
                  </a>
                </div>
              </div>
              <div className="col-lg-6 col-6 main-header-navigation">
                <div className="main-nav">
                  <nav>
                    <ul className="main-menu d-none d-lg-inline">
                      <li className="">
                        <a href="/">
                          <img src={process.env.PUBLIC_URL + "/showbiz-assets/images/icon-home.svg"} alt="Trang chủ" className="" />
                          Trang chủ
                        </a>
                      </li>
                      <li className="">
                        <a href="/tin-moi">
                          <img src={process.env.PUBLIC_URL + "/showbiz-assets/images/icon-tin-moi-nhat.svg"} alt="Trang chủ" className="" />

                          Tin mới nhất
                        </a>
                      </li>
                      <li className="">
                        <a href="/trending">
                          <img src={process.env.PUBLIC_URL + "/showbiz-assets/images/icon-top-trending.svg"} alt="Trang chủ" className="" />

                        Top trending</a>

                      </li>
                      <li><a href="/video">
                        <img src={process.env.PUBLIC_URL + "/showbiz-assets/images/icon-video.svg"} alt="Trang chủ" className="" />

                      Video</a></li>
                    </ul>
                    <div className="d-inline ml-50 tools-icon d-lg-none">
                      <a className="red-tooltip text-danger" href="/tin-moi" data-toggle="tooltip" data-placement="top" title="" data-original-title="Hot Topics">
                        <img src={process.env.PUBLIC_URL + "/showbiz-assets/images/icon-tin-moi.svg"} alt="Trang chủ" className="" />
                      </a>
                      <a className="red-tooltip text-primary" href="/trending" data-toggle="tooltip" data-placement="top" title="" data-original-title="Trending">
                        <img src={process.env.PUBLIC_URL + "/showbiz-assets/images/icon-top-trending.svg"} alt="Trang chủ" className="" />

                      </a>
                      <a className="red-tooltip text-success" href="/video" data-toggle="tooltip" data-placement="top" title="" data-original-title="Notifications">
                        <img src={process.env.PUBLIC_URL + "/showbiz-assets/images/icon-video.svg"} alt="Trang chủ" className="" />

                      </a>
                    </div>
                  </nav>
                </div>
              </div>
              <div className="col-lg-3 col-12 pr-lg-0">
                {/* <!-- Search --> */}
                <form
                  className="search-form d-lg-inline float-right position-relative d-none"
                >
                  <input type="text" className="search_field" placeholder="Tìm kiếm" value='' name="q" onChange={()=>{}}/>
                  <span className="search-icon"><i className="ti-search mr-5"></i></span>
                </form>
                {/* <!-- Off canvas --> */}
                <div className="off-canvas-toggle-cover">
                  <div className="off-canvas-toggle hidden d-inline-block ml-15" id="off-canvas-toggle">
                    <ion-icon name="grid-outline"></ion-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* BANNER */}
      <div className="container">
        <div className="row">
          <div className="col-12 text-center mt-30 mb-30" id="sb-top">
            <a href="#">
                <img className="border-radius-10 d-inline" src="http://via.placeholder.com/970x250" alt="post-slider" />
              </a>
          </div>
        </div>
      </div>

    </React.Fragment>

  );
}


ShowbizPreviewHeader.propTypes = {
  postContent: PropTypes.object
};


export default ShowbizPreviewHeader;
